const INDEX_ITEMS = [
  { title: '热门搞笑综艺', desc: '爆笑不断，解压必备', icon: 'ri-emotion-laugh-line', color: 'bg-primary-100 text-primary-600', count: '36部' },
  { title: '真人秀精选', desc: '明星生活大揭秘', icon: 'ri-user-star-line', color: 'bg-accent-100 text-accent-700', count: '28部' },
  { title: '音乐竞演综艺', desc: '天籁之音，巅峰对决', icon: 'ri-music-line', color: 'bg-secondary-100 text-secondary-600', count: '22部' },
  { title: '旅行体验综艺', desc: '足不出户环游世界', icon: 'ri-earth-line', color: 'bg-primary-100 text-primary-600', count: '19部' },
  { title: '治愈慢综艺', desc: '慢下来，感受生活美好', icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-700', count: '15部' },
  { title: '推理探案综艺', desc: '烧脑解谜，斗智斗勇', icon: 'ri-brain-line', color: 'bg-secondary-100 text-secondary-600', count: '12部' },
  { title: '经典怀旧综艺', desc: '重温那些年的欢乐', icon: 'ri-history-line', color: 'bg-primary-100 text-primary-600', count: '24部' },
];

const UPDATES = [
  { date: '07.31', title: '《奔跑吧兄弟》最新季上线，全新阵容引爆笑点', tag: '热播' },
  { date: '07.30', title: '《向往的生活》暖心收官，本季评分再创新高', tag: '完结' },
  { date: '07.29', title: '《明星大侦探》第十季官宣，原班人马回归', tag: '预告' },
  { date: '07.28', title: '《乘风破浪的姐姐》成团夜，精彩舞台全收录', tag: '热门' },
  { date: '07.27', title: '《中餐厅》新一季选址曝光，异国美食之旅', tag: '资讯' },
  { date: '07.26', title: '《密室大逃脱》新主题上线，高能场面不断', tag: '上新' },
  { date: '07.25', title: '《这！就是街舞》总决赛，世界级舞者巅峰对决', tag: '热门' },
  { date: '07.24', title: '《极限挑战》十周年特别企划，情怀与欢乐并存', tag: '专题' },
];

const COMMENTS = [
  { name: '综艺达人小王', text: '每天下班就等着看6789影视更新的综艺，高清不卡顿，比别的平台舒服太多了！', time: '2小时前', avatar: 'ri-user-3-line' },
  { name: '追综少女', text: '搞笑综艺合集太好用了，再也不用到处找资源，一个网站全搞定，真心推荐！', time: '5小时前', avatar: 'ri-user-smile-line' },
  { name: '周末看综艺', text: '更新速度真的快，热门综艺当天就能看到高清版，已经推荐给身边所有朋友了。', time: '1天前', avatar: 'ri-user-heart-line' },
  { name: '老综艺迷', text: '从经典怀旧到最新热播，资源特别全，播放流畅度也没得说，稳稳的幸福。', time: '2天前', avatar: 'ri-user-star-line' },
];

const RANKING_ITEMS = [
  { rank: 1, title: '奔跑吧兄弟', subtitle: '最新季回归', heat: '🔥 98.6万', icon: 'ri-medal-line', color: 'text-accent-500' },
  { rank: 2, title: '明星大侦探', subtitle: '第十季官宣', heat: '🔥 92.3万', icon: 'ri-medal-line', color: 'text-foreground-400' },
  { rank: 3, title: '向往的生活', subtitle: '暖心收官', heat: '🔥 87.1万', icon: 'ri-medal-line', color: 'text-secondary-500' },
  { rank: 4, title: '乘风破浪的姐姐', subtitle: '成团之夜', heat: '🔥 81.5万', icon: 'ri-trophy-line', color: 'text-foreground-300' },
  { rank: 5, title: '密室大逃脱', subtitle: '新主题上线', heat: '🔥 76.8万', icon: 'ri-trophy-line', color: 'text-foreground-300' },
  { rank: 6, title: '这！就是街舞', subtitle: '总决赛', heat: '🔥 72.4万', icon: 'ri-trophy-line', color: 'text-foreground-300' },
];

export function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">热门专题合集</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">按类型快速找到你喜欢的综艺，每日更新最新内容</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-100 rounded-xl p-4 md:p-5 text-center cursor-pointer hover:bg-primary-50 transition-all duration-200"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${item.color} flex items-center justify-center mx-auto mb-3 text-lg md:text-xl group-hover:scale-110 transition-transform`}>
                <i className={item.icon}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2 hidden sm:block">{item.desc}</p>
              <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">有好的综艺资源推荐？欢迎投稿合作，一起丰富综艺大全</p>
        <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-6 md:p-8">
          <form
            id="contact-form-6789"
            data-readdy-form=""
            action="https://readdy.ai/api/form/d9m886obdkpk99j7g7u0"
            method="POST"
            encType="application/x-www-form-urlencoded"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const spamField = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
              if (spamField && spamField.value.trim() !== '') return;
              const fd = new FormData(form);
              const body = new URLSearchParams();
              fd.forEach((v, k) => { body.append(k, v as string); });
              try {
                const resp = await fetch(form.action, { method: 'POST', body });
                const txt = await resp.text();
                let parsed;
                try { parsed = JSON.parse(txt); } catch { parsed = null; }
                const msgEl = document.getElementById('contact-msg');
                if (resp.ok && parsed?.code === 'OK') {
                  if (msgEl) { msgEl.textContent = '提交成功，我们会尽快回复！'; msgEl.className = 'text-sm text-green-600 mt-3 text-center'; }
                  form.reset();
                } else {
                  const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '';
                  if (serverMsg.includes('spam')) {
                    if (msgEl) { msgEl.textContent = '提交成功，我们会尽快回复！'; msgEl.className = 'text-sm text-green-600 mt-3 text-center'; }
                    form.reset();
                  } else {
                    if (msgEl) { msgEl.textContent = serverMsg || '提交失败，请稍后重试'; msgEl.className = 'text-sm text-red-500 mt-3 text-center'; }
                  }
                }
              } catch {
                const msgEl = document.getElementById('contact-msg');
                if (msgEl) { msgEl.textContent = '网络错误，请稍后重试'; msgEl.className = 'text-sm text-red-500 mt-3 text-center'; }
              }
            }}
          >
            <div className="flex flex-col gap-4">
              <input type="text" name="name" placeholder="你的昵称" required className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors" />
              <input type="email" name="email" placeholder="联系邮箱" required className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors" />
              <textarea name="message" placeholder="请描述你想推荐或咨询的综艺内容..." required maxLength={500} rows={4} className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none"></textarea>
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="spam-field" />
              <button type="submit" className="w-full py-3 rounded-xl bg-primary-500 text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">发送消息</button>
            </div>
            <div id="contact-msg"></div>
          </form>
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">热门综艺每日更新，精彩内容不容错过</p>
        <div className="max-w-3xl mx-auto">
          {UPDATES.map((item, i) => (
            <div key={i} className={`flex items-start gap-4 py-4 ${i < UPDATES.length - 1 ? 'border-b border-background-200' : ''}`}>
              <span className="text-xs font-semibold text-foreground-400 whitespace-nowrap mt-0.5 w-12">{item.date}</span>
              <span className="text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap mt-0.5 bg-primary-100 text-primary-600">{item.tag}</span>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed flex-1">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">观众热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">看看大家都在聊哪些综艺</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {COMMENTS.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-500">
                  <i className={`${c.avatar} text-lg`}></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">综艺热度榜</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">实时更新热门综艺排行，看看大家都在追什么</p>
        <div className="max-w-2xl mx-auto bg-background-100 rounded-2xl overflow-hidden">
          {RANKING_ITEMS.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-5 py-4 ${i < RANKING_ITEMS.length - 1 ? 'border-b border-background-200' : ''} hover:bg-background-200/50 transition-colors cursor-pointer`}
            >
              <span className={`text-lg font-heading font-bold w-8 text-center ${item.color}`}>
                {item.rank <= 3 ? <i className={item.icon}></i> : item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-semibold text-foreground-800 truncate">{item.title}</div>
                <div className="text-xs text-foreground-500">{item.subtitle}</div>
              </div>
              <span className="text-xs md:text-sm font-medium text-primary-500 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">精彩片段</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">热门综艺高光时刻，高清流畅随心看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          <MediaCard
            imgSrc="https://readdy.ai/api/search-image?query=Modern%20variety%20show%20studio%20with%20colorful%20LED%20screens%20and%20dynamic%20lighting%20professional%20broadcast%20stage%20entertainment%20production%20warm%20ambient%20glow%20cinematic%20photography&width=800&height=450&seq=media-card-01&orientation=landscape"
            title="奔跑吧兄弟 · 最新特辑"
            duration="1:28:36"
            category="搞笑真人秀"
            views="128万"
          />
          <MediaCard
            imgSrc="https://readdy.ai/api/search-image?query=Healing%20slow%20variety%20show%20countryside%20setting%20warm%20natural%20light%20cozy%20rustic%20kitchen%20garden%20scene%20soft%20cinematic%20photography%20with%20golden%20hour%20tones&width=800&height=450&seq=media-card-02&orientation=landscape"
            title="向往的生活 · 收官篇"
            duration="1:35:12"
            category="治愈慢综艺"
            views="96万"
          />
          <MediaCard
            imgSrc="https://readdy.ai/api/search-image?query=Mystery%20detective%20variety%20show%20studio%20set%20with%20dramatic%20shadows%20investigation%20props%20and%20suspenseful%20atmospheric%20lighting%20modern%20production%20design&width=800&height=450&seq=media-card-03&orientation=landscape"
            title="明星大侦探 · 高能推理"
            duration="1:42:08"
            category="推理探案"
            views="115万"
          />
          <MediaCard
            imgSrc="https://readdy.ai/api/search-image?query=Music%20competition%20show%20stage%20with%20dramatic%20concert%20lighting%20professional%20sound%20equipment%20vibrant%20performance%20atmosphere%20colorful%20spotlights%20and%20fog%20effects&width=800&height=450&seq=media-card-04&orientation=landscape"
            title="乘风破浪的姐姐 · 舞台纯享"
            duration="58:24"
            category="音乐竞演"
            views="89万"
          />
          <MediaCard
            imgSrc="https://readdy.ai/api/search-image?query=Travel%20adventure%20variety%20show%20concept%20with%20exotic%20destinations%20warm%20cinematic%20travel%20aesthetic%20beautiful%20landscape%20and%20cultural%20elements%20golden%20sunset%20lighting&width=800&height=450&seq=media-card-05&orientation=landscape"
            title="中餐厅 · 美食之旅"
            duration="1:15:50"
            category="旅行体验"
            views="73万"
          />
        </div>
      </div>
    </section>
  );
}

function MediaCard({ imgSrc, title, duration, category, views }: {
  imgSrc: string;
  title: string;
  duration: string;
  category: string;
  views: string;
}) {
  return (
    <div className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
      <div className="relative aspect-video overflow-hidden">
        <img
          src={imgSrc}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md">
          {duration}
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
            <i className="ri-play-fill text-white text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-800 line-clamp-1 mb-1">{title}</h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{category}</span>
          <span><i className="ri-eye-line mr-1"></i>{views}</span>
        </div>
      </div>
    </div>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-background-100 to-primary-50 rounded-3xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">移动端观影体验</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              6789影视移动端适配，随时随地观看热门综艺、搞笑综艺、真人秀综艺免费全集。
              高清流畅不缓冲，通勤路上、午休时间，打开就能看。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all text-center">
                <i className="ri-smartphone-line mr-2"></i>手机端访问
              </a>
              <span className="text-xs text-foreground-400 whitespace-nowrap">无需下载，浏览器直接观看</span>
            </div>
          </div>
          <div className="w-40 h-56 md:w-48 md:h-64 bg-background-200 rounded-3xl overflow-hidden border-4 border-background-300 flex-shrink-0">
            <div className="w-full h-full bg-gradient-to-b from-primary-400/30 to-background-100 flex flex-col items-center justify-center gap-3 p-4">
              <i className="ri-play-circle-fill text-primary-500 text-3xl"></i>
              <span className="text-xs font-semibold text-foreground-600 text-center">综艺在线观看</span>
              <span className="text-xs text-foreground-400 text-center">高清综艺 · 每日更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}